import { Bone } from '../primitives';

// Matches CreatePodcast.js's 2-column layout: general/publishing form cards on the left,
// a sticky image-picker card on the right.
export default function CreatePodcastSkeleton() {
    return (
        <div className="row mt-4">
            <div className="col-md-8">
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 20, marginBottom: 20 }}>
                    <Bone h={16} w={140} style={{ marginBottom: 16 }} />
                    {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} style={{ marginBottom: 14 }}>
                            <Bone h={11} w={100} style={{ marginBottom: 6 }} />
                            <Bone h={36} w="100%" />
                        </div>
                    ))}
                </div>
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 20 }}>
                    <Bone h={16} w={160} style={{ marginBottom: 16 }} />
                    <Bone h={30} w="100%" />
                </div>
            </div>
            <div className="col-md-4">
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 16 }}>
                    <Bone h={160} r={10} style={{ marginBottom: 14 }} />
                    <Bone h={38} w="100%" r={9} />
                </div>
            </div>
        </div>
    );
}
